import { z } from "zod";
import { MAX_SLOTS } from "../constants";

export const HOTKEY_MAX_LEN = 64;

/** One slot of a configuration. Its array position is its playback position. */
export const slotEntrySchema = z
  .object({
    personId: z.uuid(),
    active: z.boolean(),
    hotkey: z.string().trim().max(HOTKEY_MAX_LEN).nullable(),
  })
  .strict();

/** Full ordered list; replaces every slot of the configuration in one batch. */
export const slotsReplaceSchema = z
  .object({
    slots: z.array(slotEntrySchema).max(MAX_SLOTS),
  })
  .strict();

export type SlotEntry = z.infer<typeof slotEntrySchema>;
export type SlotsReplace = z.infer<typeof slotsReplaceSchema>;
